module.exports = __webpack_public_path__ + "static/media/six.8fc98747.jpg";